
<template>

	<div>
		<window_portal v-if="x_attr && y_attr" v-model="open_modal" :title="title" v-slot="modal_ref">
			<div class="p-2">
				<div class="btn_group">

					<b-button v-if="check_roles([ 'model' ])" size="sm" variant="outline-primary" data-tooltip="Отмена последнего действия" v-on:click="bring_back"><base-icon name="actions_undo" style="pointer-events: none" /></b-button>

					<b-button v-if="check_roles([ 'model' ])" size="sm" variant="outline-primary" data-tooltip="Вернуть в исходное состояние" v-on:click="reset_state"><base-icon name="broomstick" style="pointer-events: none" /></b-button>

					<b-button v-if="plot_type == 'Все'" size="sm" variant="outline-primary" data-tooltip="Скрыть выбросы" id="plot_type_not_excluded_window" v-on:click="() => set_plot_type('Не выбросы')"><base-icon name="blowout_open" style="pointer-events: none" /></b-button>

					<b-button v-if="plot_type != 'Все'" size="sm" variant="outline-primary" data-tooltip="Отобразить все" id="plot_type_all_window" v-on:click="() => set_plot_type('Все')"><base-icon name="blowout_close" style="pointer-events: none" /></b-button>

					<!-- <b-button v-if="check_roles([ 'model' ])" size="sm" :variant="(set_selected ? '' :'outline-') + 'primary'" data-tooltip="Лассо - выбор" id="lasso_window" v-on:click="() => { set_selected = ! set_selected }"><base-icon name="lasso" style="pointer-events: none" /></b-button>

					<b-button v-if="check_roles([ 'model' ])" size="sm" variant="outline-primary" data-tooltip="Сбросить выбор" id="reset_selected_window" v-on:click="reset_selected"><base-icon name="lasso_off" style="pointer-events: none" /></b-button> -->

				</div>

				<div align="center" v-if="is_init && objects != null && x_attr != null && y_attr != null && plot_id != null">

					<plot ref="plot_modal" class="mt-2" :plot_id="plot_id + '_modal'" :plot_type="plot_type" :set_selected="set_selected"
						:with_regression="with_regression" :with_line="with_line" :with_area="with_area" :with_zoom="with_zoom" :with_x_axis_title="with_x_axis_title" is_window :window_ref="modal_ref"
						:objects="objects" :x_attr="x_attr" :y_attr="y_attr"
						v-on:toggle_objects="ev => $emit('toggle_objects', ev)"
						:seq_x="seq_x"
					/>

				</div>
			</div>
		</window_portal>

		<div class="d-flex mt-2 justify-content-between align-items-center">

			<div class="btn_group">

				<b-button v-if="check_roles([ 'model' ])" size="sm" variant="outline-primary" v-b-tooltip:fullscreen.hover.bottomright="'Отмена последнего действия'" v-on:click="bring_back"><base-icon name="actions_undo" /></b-button>
	
				<b-button v-if="check_roles([ 'model' ])" size="sm" variant="outline-primary" v-b-tooltip:fullscreen.hover.bottomright title="Вернуть в исходное состояние" v-on:click="reset_state"><base-icon name="broomstick" /></b-button>
				<b-button v-if="plot_type == 'Все'" size="sm" variant="outline-primary" v-b-tooltip:fullscreen.hover.bottomright title="Скрыть выбросы" v-on:click="() => set_plot_type('Не выбросы')"><base-icon name="blowout_open" /></b-button>
				<b-button v-else size="sm" variant="outline-primary" v-b-tooltip:fullscreen.hover.bottomright title="Отобразить все" v-on:click="() => set_plot_type('Все')"><base-icon name="blowout_close" /></b-button>
		
				<!-- <b-button v-if="check_roles([ 'model' ])" size="sm" :variant="(set_selected ? '' :'outline-') + 'primary'" v-b-tooltip:fullscreen.hover.bottomright title="Лассо - выбор" v-on:click="() => { set_selected = ! set_selected }"><base-icon name="lasso" /></b-button>

				<b-button v-if="check_roles([ 'model' ])" size="sm" variant="outline-primary" v-b-tooltip:fullscreen.hover.bottomright title="Сбросить выбор" v-on:click="reset_selected"><base-icon name="lasso_off" /></b-button> -->

				
			</div>
			
			<b-button size="sm" class="transparent" v-b-tooltip:fullscreen.hover.bottomright="'Открыть в окне'" v-on:click="() => open_modal = !open_modal"><base-icon name="Full - Short_open" /></b-button>
		</div>
	
		<div align="center" v-if="is_init && objects != null && x_attr != null && y_attr != null && plot_id != null" style="height: 300px;">
	
			<plot ref="plot" class="mt-2" :plot_id="plot_id" :plot_type="plot_type" :set_selected="set_selected"
				:with_regression="with_regression" :with_line="with_line" :with_area="with_area" :with_zoom="with_zoom" :with_x_axis_title="with_x_axis_title"
				:objects="objects" :x_attr="x_attr" :y_attr="y_attr"
				v-on:toggle_objects="ev => $emit('toggle_objects', ev)"
				@get_plot_data="(data) => $emit('get_plot_data', data)"
				@get_regression="(data) => $emit('get_regression', data)"
				:seq_x="seq_x"
			/>
	
		</div>

	</div>

</template>

<script>

import { uuid } from "vue-uuid"
import * as d3 from "d3"
import plot from "./plot"
import o from "./objects"
import attrs from "../../../../../../api/attrs"
import window_portal from "../../../../../widgets/window_portal"
import { bus } from "../../../../../../api/bus"
import api from "../../../../../../api"

export default
{
	props :
	{
		group_id : String,
		x_attr_key : String,
		x_attr_name : String,
		y_attr_key : String,
		bad_attr_key : String,
		sort_by : String,
		query : Object,
		title : String,
		with_regression : { type : Boolean, default : () => false },
		with_zoom : { type : Boolean, default : () => false },
		with_x_axis_title : { type : Boolean, default : () => false },
		with_line : { type : Boolean, default : () => false },
		with_area : { type : Boolean, default : () => false },
		seq_x : { type : Array, default : () => null },
	},

	components :
	{
		plot,
		window_portal,
	},

	data()
	{
		return {

			set_selected : false,

			objects : null,
			x_attr : null,
			y_attr : null,

			is_init : false,
			hide_bad : false,

			plot_id : null,
			plot_type : "Все",
			plot_types : [ "Все", "Обучающая выборка", "Контрольная выборка" ],

			open_modal : false,

			// Стек операций
			operations : [],

		}
	},

	mounted()
	{
		window.addEventListener("keydown", this.key_down)
		
		this.plot_id = uuid.v1()

		d3.select("#good_" + this.plot_id)
			.append("svg").attr("width", 20).attr("height", 20)
			.append("circle").attr("cx", 10).attr("cy", 10).attr("r", 6).style("fill", "green")

		const bad_symbol = d3.symbol().type(d3.symbolCross).size(75)

		d3.select("#bad_" + this.plot_id)
			.append("svg").attr("width", 20).attr("height", 20)
			.append("path").attr("d", bad_symbol).attr("transform", "translate(10, 10) rotate(45)").style("fill", "black")

		return attrs.get(this)
			.then(
				desc =>
				{
					this.objects = new o.Objects(this, this.group_id, desc.attrs, this.bad_attr_key, operation => this.operations.push(operation), this.sort_by, this.query)

					this.objects.bus.$on("update_plots",
						() => 
						{
							if(this.$refs.plot)
								this.$refs.plot.refresh()

							if(this.$refs.plot_modal)
								this.$refs.plot_modal.refresh()
							
							this.$emit("need_refresh")
						})

					this.y_attr = desc.attrs.find(attr => attr.key == this.y_attr_key)
					
					if (!this.has_oks && this.y_attr_key === "attrs.rent_price")
					{
						this.y_attr.name = this.y_attr.name.replace("ед. изм.", "кв. м")
					}

					if(this.x_attr_key == "index")
						this.x_attr = { name : "Порядковый номер объекта-аналога", key : "index", type : "number" }
					else
						this.x_attr = api.deep_clone(desc.attrs.find(attr => attr.key == this.x_attr_key))

					if(this.x_attr_name != null)
						this.x_attr.name = this.x_attr_name
				})
			.then(() => this.objects.refresh_objects())
			.then(() => { this.is_init = true })
	},

	beforeDestroy()
	{
		window.removeEventListener("keydown", this.key_down)
	},

	computed :
	{
		has_oks()
		{
			return api.has_oks()
		}
	},

	methods :
	{
        check_roles(roles)
        {
            return api.check_roles(this, roles)
        },

		refresh()
		{
			this.objects.refresh_objects().then(
				() =>
				{
					if(this.$refs.plot)
						this.$refs.plot.refresh()

					if(this.$refs.plot_modal)
						this.$refs.plot_modal.refresh()
				})
		},

		plot_type_context_menu(ev)
		{
			ev.preventDefault()
			this.$refs.plot_type_context_menu.open(ev)
		},

		set_plot_type(plot_type)
		{
			this.plot_type = plot_type
		},

		reset_selected()
		{
			this.objects.reset_selected()
		},

		reset_state()
		{
			this.objects.reset_state()
		},

		bring_back()
		{
			if(this.operations.length > 0)
			{
				const operation = this.operations.pop()

				if(operation.type == "set_objs_state")
				{
					const objects = this.objects.objects_by_ids(operation.obj_ids)

					this.$emit('toggle_objects', { objects : objects, state : !operation.old_bad })
					this.objects.set_state(operation.obj_ids, operation.old_bad, false)
				}
			}
		},

		key_down(ev)
		{
			ev.stopPropagation()

			if(ev.code == "Escape")
				bus.$emit("reset_lasso")
		},
	}
}

</script>
